const Data = [
  {
    question: "Что такое bubble tea?",
    answer:
      "Чай с шариками, также бабл-ти или жемчужный чай — чайный напиток с добавлением шариков из тапиоки, также называемыми «боба» и «жемчужины». Большинство рецептов включает чайную основу, смешанную с фруктовым соком или молоком; подаётся горячим или со льдом.",
    image: require("./bubble_tea.gif")
  },
  {
    question: "Что такое тапиока?",
    answer:
      "Тапиока - это шарики, которые мы бережно делаем из тростникового сахара и крахмала, получаемого из корней маниок. Высококалорийная и легко усваиваемая пища, которая прекрасно заменит перекус из нескольких бургеров, и широко употребляется в теплых тропических странах. По вкусу тапиока медово-карамельная и жуется, как мармелад.",
    image: require("./tapioka.gif")
  },
  {
    question: "У вас есть шарики, которые лопаются?",
    answer:
      "Да, у нас есть тапиока-желе со следующими вкусами: манго, виноград, персик и сакура.",
    image: require("./balls.gif")
  },
  {
    question: "Какое альтернативное молоко вы используете?",
    answer:
      "В нашем кафе вы можете заменить молочную часть напитка на растительное молоко Alpro трех видов: кокосовое, соевое и миндальное.",
    image: require("./milk.gif")
  },
  {
    question: "Можно ли сделать фраппе без льда?",
    answer:
      "К сожалению, нет. Фраппе это описание консистенции напитка. Он представляет собой взбитый блендером лед и больше напоминает мороженое, чем чай в классическом виде.",
    image: require("./frappe.gif")
  },
  {
    question: "Можно ли сделать чай с сырной пенкой горячим?",
    answer:
      "И снова спешим вас огорчить. Чаи с воздушным сыром можно сделать только холодными и теплыми, так как шапочка из воздушного сыра хоть и имеет высокую плотность, но в горячих напитках всё же начинает растворяться.",
    image: require("./pena.gif")
  },
  {
    question: "Фруктовые чаи идут на основе сиропов?",
    answer:
      "Концепция использования натуральных продуктов предполагает отказ от различных концентрированных сиропов. Все сиропы, которые вы можете увидеть в составах фруктовых чаев - мы готовим самостоятельно на основе фруктов и ягод с добавлением сахара.",
    image: require("./syrop.gif")
  },
  {
    question: "Можно с собой?",
    answer:
      "Конечно, можно! Все напитки мы предоставляем в полностью герметичных стаканах, покрытых специальной пленкой. Вы можете положить напиток в сумку или пакет.",
    image: require("./togo.gif")
  }
];
export default Data;
